import axios from './httpConfig.js'
//******************系统参数管理 -- 出入库类型 ******************/
// 出入库类型列表
export function GetInOutTypeList(param) {
	return axios.post('/admin/inouttype/list', param)
}

// 新增出入库类型
export function AddInOutType(param) {
	return axios.post('/admin/inouttype/add', param)
}

// 禁用出入库类型
export function DisabledInOutType(param) {
	return axios.post('/admin/inouttype/disabled', param)
}

// 删除出入库类型
export function DeleteInOutType(param) {
	return axios.post('/admin/inouttype/delete', param)
}

// 修改出入库类型
export function EditInOutType(param) {
	return axios.post('/admin/inouttype/edit', param)
}

// 设置默认选中
export function Setdefault(param) {
	return axios.post('/admin/inouttype/setdefault', param)
}

//******************系统参数管理 -- 系统日志管理 ******************/
// 日志列表
export function GetLogList(param) {
	return axios.post('/admin/log/list', param)
}
// 日志删除
export function DeleteLogList(param) {
	return axios.post('/admin/log/delete', param)
}

//******************系统参数管理 -- 系统菜单管理 ******************/
// 功能菜单 全树接口（用于角色权限 配置界面）
export function GetMenuTree(param) {
	return axios.post('/admin/system/menu/tree', param)
}

// 功能菜单树接口--设置权限后的树
export function GetRoleMenuTree(param) {
	return axios.post('/admin/user/menu', param)
}

// 页面按钮接口--设置权限后
export function GetRoleButton(param) {
	return axios.post('/admin/user/button', param)
}

// 列表 -- 懒加载
export function GetSystemMenuLazy(param) {
	return axios.post('/admin/system/menu/tree/children', param)
}

// 新增 功能菜单（用于管理页面【超级管理员权限】）
export function AddSystemMenu(param) {
	return axios.post('/admin/system/menu/add', param)
}

// 修改 功能菜单（用于管理页面【超级管理员权限】）
export function EditSystemMenu(param) {
	return axios.post('/admin/system/menu/edit', param)
}

// 删除 功能菜单（用于管理页面【超级管理员权限】）
export function DeleteSystemMenu(param) {
	return axios.post('/admin/system/menu/delete', param)
}

// 禁用 功能菜单（用于管理页面【超级管理员权限】）
export function DisableSystemMenu(param) {
	return axios.post('/admin/system/menu/disabled', param)
}

// 获取 图标列表
export function GetIcons(param) {
	return axios.post('/public/getIcons', param)
}

// 设为系统级菜单
export function SetSystemMenu(param) {
	return axios.post('/admin/system/menu/setsystem', param)
}

//******************系统参数管理 -- ERP单据类型 ******************/
// ERP单据类型列表
export function GetErpBillTypeList(param) {
	return axios.post('/admin/erp/order/type/list', param)
}

// 新增ERP单据类型
export function AddErpBillType(param) {
	return axios.post('/admin/erp/order/type/add', param)
} 

// 删除ERP单据类型
export function DeleteErpBillType(param) {
	return axios.post('/admin/erp/order/type/delete', param)
}

// 修改ERP单据类型
export function EditErpBillType(param) {
	return axios.post('/admin/erp/order/type/edit', param)
} 

// 禁用ERP单据类型
export function DisabledErpBillType(param) {
	return axios.post('/admin/erp/order/type/disabled', param)
}
